var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-subsection-list-color"},[_c('div',{staticClass:"bb-subsection-list-color__icon",style:({
      color: ("rgba(" + (_vm.item.color) + ", 1)"),
      background: ("rgba(" + (_vm.item.color) + ", 0.15)")
    }),domProps:{"innerHTML":_vm._s(_vm.BackgroundIcon())},on:{"click":function($event){return _vm.onOpenColorPicker($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52357b64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/Services/SubsectionList/SubsectionListColor.vue
// module id = null
// module chunks = 